export const c_tree_view_m_guides_guide_color_base = {
  "name": "--pf-c-tree-view--m-guides--guide-color--base",
  "value": "#d2d2d2",
  "var": "var(--pf-c-tree-view--m-guides--guide-color--base)"
};
export default c_tree_view_m_guides_guide_color_base;